// 路由配置
let routes = [
    // 首页
    {
        path: '/index',
        name: 'homepage',
        component: () => import('@/views/Index.vue'),
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/detail.vue'),
    },
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/login.vue'),
    },
    // 404
    {
        path: '*',
        name: 'notfount',
        component: () => import('@/views/404.vue'),
    }
];

routes = [...routes];

export default routes;
